import React from 'react';

export default function Card(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M24.344 6H7c-1.104 0-2.052.396-2.844 1.188C3.386 7.957 3 8.896 3 10v12c0 1.104.385 2.052 1.156 2.844A3.933 3.933 0 007 26h17.344c1.104 0 2.041-.385 2.812-1.156.792-.792 1.188-1.74 1.188-2.844V10c0-1.104-.396-2.042-1.188-2.813C26.386 6.396 25.448 6 24.344 6zM27 22c0 .73-.26 1.354-.781 1.875-.521.52-1.146.781-1.875.781H7c-.73 0-1.354-.26-1.875-.781A2.557 2.557 0 014.344 22v-6.688H27V22zM4.344 10c0-.75.26-1.385.781-1.906A2.557 2.557 0 017 7.313h17.344c.729 0 1.354.26 1.875.78.52.522.781 1.157.781 1.907H4.344z"
        fill="#fff"
      />
    </svg>
  );
}
